import * as React from "react";
import { Provider } from "@fluentui/react-northstar/dist/es/components/Provider/Provider";
import { useState, useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import CpbxLogin from "../../components/CpbxLogin/CpbxLogin";
import CpbxDirectory from "../../components/CpbxDirectory/CpbxDirectory";
import { ICpbxLoginProps } from "../../components/CpbxLogin/ICpbxLoginProps";
import DataPrivacyLastUpdated from "../../components/DataPrivacyLastUpdated/DataPrivacyLastUpdated";
import { CpbxThemeSelector } from "../../components/CpbxThemeSelector/CpbxThemeSelector";
import Verhinderung from "../../components/Verhinderung/Verhinderung";

/**
 * Implementation of the TabCpbxDirectory content page
 */
export const TabCpbxDirectory = () => {

    const [{ inTeams, theme, context }] = useTeams();
    const [entityId, setEntityId] = useState<string>();

    // we need azure user object-id for each request to xsi or ums (as part of decryption-stuff)
    const [msTeamsUid, setUserObjectId] = useState<string>();

    // check if login has been done already
    const isCpbxLoggedIn: boolean = LocalCacheHelper.DoesLocalCacheKeysForCbpxLoginExists();

    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.appInitialization.notifySuccess();
        }
        if (inTeams === false) {
            const outContext = { theme: "default" };
            CpbxThemeSelector(outContext);
        }
    }, [inTeams]);

    useEffect(() => {
        microsoftTeams.registerOnThemeChangeHandler(function(theme) {
            CpbxThemeSelector(theme);
            console.log(theme);
        });
        if (context) {
            setEntityId(context.entityId);
            setUserObjectId(context.userObjectId);
            // Theme Switcher
            CpbxThemeSelector(context);
        }
    }, [context]);

    if (isCpbxLoggedIn) {
        return (
            <Provider theme={theme} className="cpbxProviderContainer">
                <DataPrivacyLastUpdated />
                <CpbxDirectory />
            </Provider>
        );

    } else {
        // azure user object-id is just needed as dynamically retrieved data while login
        // if login succeeded this value will be stored to local-storage / session-storage
        const localDevTestUserId = "11111111-1111-1111-1111-111111111111";
        const cpbxLoginProps: ICpbxLoginProps = { M365UserObjectId: (msTeamsUid ?? localDevTestUserId) };

        return (
            <Provider theme={theme} className="cpbxProviderContainer">
                {/*   <DataPrivacyLastUpdated />
                <CpbxLogin {...cpbxLoginProps} />   */}
                <Verhinderung/>
            </Provider>
        );
    }
};
